import { Role } from '@/router/_helper';

const prep = {
  path: '/prep',
  name: 'TestPrep',
  component: () =>
    import(
      /* webpackChunkName: "testPrep" */ '@/components/academic/TestPrep.vue'
    ),
  meta: { authorize: [Role.ViewAcademic], requiresAuth: true },
};

export default prep;
